export const displayPin = {
    displayedOnExternalDevice: false,
};
